export default class LocationsMap {
	private readonly items: LocationItem[];

	constructor(public readonly section: HTMLElement) {
		const markerElements: HTMLDivElement[] = Array.from(this.section.querySelectorAll('.map-marker'));
		this.items = markerElements.map((element) => new LocationItem(this, element));
	}
}

class LocationItem {
	private readonly id: string = this.marker.dataset.location as string;
	private readonly listItem: HTMLLIElement = this.map.section.querySelector(`.grid > li[data-location="${this.id}"]`) as HTMLLIElement;

	constructor(private readonly map: LocationsMap, private readonly marker: HTMLDivElement) {
		for (const element of [this.listItem, this.marker]) {
			element.addEventListener('mouseenter', () => this.isActive = true);
			element.addEventListener('mouseleave', () => this.isActive = false);
		}
	}

	private set isActive(isActive: boolean) {
		this.listItem.classList.toggle('active', isActive);
		this.marker.classList.toggle('active', isActive);
	}
}
